import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getHistoricalDrafts } from "../../../features/state/StateDraft-slice";
import { GenerateColumnDefinition, GenerateDraftColumnDefinition } from "../../../components/stateful/table/TableHelper";
import { GenerateBlankDraft } from "../../../utilities/interfaces/Draft";
import { GridRowClickEvent } from "@progress/kendo-react-grid";
import { draftAPI } from "../../../utilities/api";

export const useHistoricalDraftsController = (props: any) => {
  const {} = props;

  const values: any[] = useAppSelector((state) => state.draft.historicalDrafts);
  const loading: boolean = useAppSelector((state) => state.draft.fetchingHistorical);
  const dispatch = useAppDispatch();

  const [columnData, setColumnData] = useState<any>([]);

  useEffect(() => {
    if (values.length < 1) {
      dispatch(getHistoricalDrafts());
    }

    if (columnData.length < 1) {
      generateColumnData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const generateColumnData = async () => {
    setColumnData(await GenerateDraftColumnDefinition(GenerateBlankDraft()))
  }

  const handleDraftSelect = async (draftId: number) => {
    setDraftPreview(await draftAPI.getPreview(draftId));
    togglePreviewDialog();
  }

  const [previewDialogOpen, setPreviewDialogOpen] = useState<boolean>(false);

  const togglePreviewDialog = () => {
    if (previewDialogOpen) {
      setDraftPreview(undefined);
    }
    setPreviewDialogOpen(!previewDialogOpen);
  }

  const [draftPreview, setDraftPreview] = useState<string>();

  return {
    values,
    columnData,
    loading,
    handleDraftSelect,
    previewDialogOpen,
    togglePreviewDialog,
    draftPreview,
  };
}